import { DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { cn } from "@/lib/utils";

interface Props {
  onCopy: () => void;
  copying: boolean;
  hasLines: boolean;
  onClose: () => void;
  onSave: () => void;
  isDirty: boolean;
  isSaving: boolean;
  readOnly?: boolean;
}

/** VIB-951: kopier mersalg som mail-vennlig tilbud + Lagre/Lukk i UpsellEditDialog. */
export function UpsellEditFooter({
  onCopy,
  copying,
  hasLines,
  onClose,
  onSave,
  isDirty,
  isSaving,
  readOnly = false,
}: Props) {
  return (
    <DialogFooter className="sm:justify-between">
      <Button
        variant="outline"
        onClick={onCopy}
        disabled={copying || !hasLines}
        title={hasLines ? "Kopier til e-post til kunde" : "Legg til linjer først"}
      >
        <SrIcon
          name={copying ? "loader2" : "mail"}
          className={cn("w-4 h-4 mr-1.5", copying && "animate-spin")}
        />
        Kopier til e-post
      </Button>
      <div className="flex gap-2">
        <Button variant="outline" onClick={onClose} disabled={isSaving}>
          Lukk
        </Button>
        {!readOnly && (
          <Button onClick={onSave} disabled={!isDirty || isSaving}>
            {isSaving ? (
              <SrIcon name="loader2" className="w-4 h-4 mr-1.5 animate-spin" />
            ) : null}
            Lagre
          </Button>
        )}
      </div>
    </DialogFooter>
  );
}
